<div class="local-container">
  <div class="filter-group">
    <mat-form-field class="range-form">
      <mat-label>{{ 'dataManagement.validator.dateRange.enter' | transloco }}</mat-label>
      <mat-date-range-input [formGroup]="rangeControl" [rangePicker]="picker">
        <input class="date-input" matStartDate formControlName="start"
          placeholder="{{ 'dataManagement.validator.dateRange.startDate' | transloco }}">
        <input class="date-input" matEndDate formControlName="end"
          placeholder="{{ 'dataManagement.validator.dateRange.endDate' | transloco }}">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
      <mat-error *ngIf="rangeControl.controls.start.hasError('matStartDateInvalid')">{{
        'dataManagement.validator.dateRange.invalidStart' | transloco }}</mat-error>
      <mat-error *ngIf="rangeControl.controls.end.hasError('matEndDateInvalid')">{{
        'dataManagement.validator.dateRange.invalidEnd' | transloco }}</mat-error>
    </mat-form-field>
    <button class="range-button" mat-raised-button color="accent" (click)="changeDateRangeByDays(-7)"
      [disabled]="rangeControl.invalid">
      {{ 'dataManagement.validator.minusOneWeek' | transloco }}
    </button>
    <button class="range-button" mat-raised-button color="accent" (click)="changeDateRangeByDays(7)"
      [disabled]="rangeControl.invalid">
      {{ 'dataManagement.validator.plusOneWeek' | transloco }}
    </button>
    <button class="filter-button" mat-raised-button color="primary" (click)="applyFilter()"
      [disabled]="rangeControl.invalid || rangeControl.pristine">
      {{ 'dataManagement.validator.filter' | transloco }}
    </button>
  </div>
  <mat-tab-group class="outer-tab-group">
    <mat-tab label="{{ 'dataManagement.validator.analysisType.recyclability' | transloco }}">
      <mat-tab-group class="tab-group" #recTabs>
        <mat-tab label="{{ 'dataManagement.validator.validationStatus.notValidated' | transloco }}">
          <div class="local-scrolling-wrapper" *ngIf="isSystemView">
            <app-packaging-systems-overview [dataSource]="recDataSourceNotValidated" [displayedColumns]="columnsNotRec"
              [isUserValidator]="true" [analysisWrappersRec]="analysisWrappersRec" sortByColumnName="creationTimestamp">
            </app-packaging-systems-overview>
          </div>
          <div class="local-scrolling-wrapper" *ngIf="!isSystemView">
            <app-packaging-units-overview [dataSource]="recDataSourceNotValidated" [displayedColumns]="columnsNotRec"
              [isUserValidator]="true" [analysisWrappersRec]="analysisWrappersRec" sortByColumnName="creationTimestamp">
            </app-packaging-units-overview>
          </div>
        </mat-tab>
        <mat-tab label="{{ 'dataManagement.validator.validationStatus.validatedPos' | transloco }}">
          <div class="local-scrolling-wrapper" *ngIf="isSystemView">
            <app-packaging-systems-overview [dataSource]="recDataSourceValidatedPos" [displayedColumns]="columnsPosRec"
              [isUserValidator]="true" [analysisWrappersRec]="analysisWrappersRec" sortByColumnName="creationTimestamp">
            </app-packaging-systems-overview>
          </div>
          <div class="local-scrolling-wrapper" *ngIf="!isSystemView">
            <app-packaging-units-overview [dataSource]="recDataSourceValidatedPos" [displayedColumns]="columnsPosRec"
              [isUserValidator]="true" [analysisWrappersRec]="analysisWrappersRec" sortByColumnName="creationTimestamp">
            </app-packaging-units-overview>
          </div>
        </mat-tab>
        <mat-tab label="{{ 'dataManagement.validator.validationStatus.validatedNeg' | transloco }}">
          <div class="local-scrolling-wrapper" *ngIf="isSystemView">
            <app-packaging-systems-overview [dataSource]="recDataSourceValidatedNeg" [displayedColumns]="columnsNegRec"
              [isUserValidator]="true" [analysisWrappersRec]="analysisWrappersRec" sortByColumnName="creationTimestamp">
            </app-packaging-systems-overview>
          </div>
          <div class="local-scrolling-wrapper" *ngIf="!isSystemView">
            <app-packaging-units-overview [dataSource]="recDataSourceValidatedNeg" [displayedColumns]="columnsNegRec"
              [isUserValidator]="true" [analysisWrappersRec]="analysisWrappersRec" sortByColumnName="creationTimestamp">
            </app-packaging-units-overview>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-tab>

    <mat-tab label="{{ 'dataManagement.validator.analysisType.lifecycle' | transloco }}">
      <mat-tab-group class="tab-group" #lcaTabs>
        <mat-tab label="{{ 'dataManagement.validator.validationStatus.notValidated' | transloco }}" selected="true">
          <div class="local-scrolling-wrapper" *ngIf="isSystemView">
            <app-packaging-systems-overview [dataSource]="lcaDataSourceNotValidated" [displayedColumns]="columnsNotLca"
              [isUserValidator]="true" [analysisWrappersLca]="analysisWrappersLca" sortByColumnName="creationTimestamp">
            </app-packaging-systems-overview>
          </div>
          <div class="local-scrolling-wrapper" *ngIf="!isSystemView">
            <app-packaging-units-overview [dataSource]="lcaDataSourceNotValidated" [displayedColumns]="columnsNotLca"
              [isUserValidator]="true" [analysisWrappersLca]="analysisWrappersLca" sortByColumnName="creationTimestamp">
            </app-packaging-units-overview>
          </div>
        </mat-tab>
        <mat-tab label="{{ 'dataManagement.validator.validationStatus.validatedPos' | transloco }}">
          <div class="local-scrolling-wrapper" *ngIf="isSystemView">
            <app-packaging-systems-overview [dataSource]="lcaDataSourceValidatedPos" [displayedColumns]="columnsPosLca"
              [isUserValidator]="true" [analysisWrappersLca]="analysisWrappersLca" sortByColumnName="creationTimestamp">
            </app-packaging-systems-overview>
          </div>
          <div class="local-scrolling-wrapper" *ngIf="!isSystemView">
            <app-packaging-units-overview [dataSource]="lcaDataSourceValidatedPos" [displayedColumns]="columnsPosLca"
              [isUserValidator]="true" [analysisWrappersLca]="analysisWrappersLca" sortByColumnName="creationTimestamp">
            </app-packaging-units-overview>
          </div>
        </mat-tab>
        <mat-tab label="{{ 'dataManagement.validator.validationStatus.validatedNeg' | transloco }}">
          <div class="local-scrolling-wrapper" *ngIf="isSystemView">
            <app-packaging-systems-overview [dataSource]="lcaDataSourceValidatedNeg" [displayedColumns]="columnsNegLca"
              [isUserValidator]="true" [analysisWrappersLca]="analysisWrappersLca" sortByColumnName="creationTimestamp">
            </app-packaging-systems-overview>
          </div>
          <div class="local-scrolling-wrapper" *ngIf="!isSystemView">
            <app-packaging-units-overview [dataSource]="lcaDataSourceValidatedNeg" [displayedColumns]="columnsNegLca"
              [isUserValidator]="true" [analysisWrappersLca]="analysisWrappersLca" sortByColumnName="creationTimestamp">
            </app-packaging-units-overview>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-tab>
  </mat-tab-group>
</div>
